import { MatFormFieldModule } from '@angular/material/form-field';
import { SpoltiDataSelectorComponent } from './spolti-data-selector/spolti-data-selector.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [SpoltiDataSelectorComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule 
  ],
  exports: [SpoltiDataSelectorComponent]
})
export class SpoltiControlsModule { }
